import { Stack, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { ToastType } from '@components';
import CommonFileUpload, {
  CommonFileUploadFiles,
} from '@components/FileUpload/CommonFileUpload';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { useParams } from '@solidjs/router';
import {
  deleteProspectDocument,
  fetchUploadedProspectDocuments,
  prospectDetailsStore,
  uploadProspectDocument,
} from '@store/prospect';
import { handleToast, isFullAdmin } from '@utils/utils';
import { Component, createSignal, onMount } from 'solid-js';

export const ProspectDetailsUploadDocuments: Component = () => {
  const [uploadedDocuments, setUploadedDocuments] = createSignal<
    {
      name: string;
      url: string;
    }[]
  >([]);
  const [loading, setLoading] = createSignal(false);

  const params = useParams();

  onMount(async () => {
    setLoading(true);
    if (params.id) {
      const res = await fetchUploadedProspectDocuments(Number(params.id));
      if (res && res.isSuccess) {
        setUploadedDocuments(res.value);
      }
    }
    setLoading(false);
  });

  const handleFileUpload = async (file: File) => {
    if (!Boolean(prospectDetailsStore.prospectDetails.id)) return;
    const formData = new FormData();
    formData.append('files', file);
    formData.append(
      'EntityId',
      prospectDetailsStore.prospectDetails.id.toString(),
    );
    formData.append('DocumentEntityType', '6');
    const res = await uploadProspectDocument(
      formData,
      CHANGE_TRACKING_SOURCES.prospectDetails.uploadDocumentsUpload,
    );
    if (res && res.isSuccess) {
      setUploadedDocuments((prev) => [
        ...prev,
        {
          name: res.value.results[0].url.split('/').pop() as string,
          url: res.value.results[0].url,
        },
      ]);
    }
  };

  const handleFileRemove = async (
    index: number,
    item: CommonFileUploadFiles,
  ) => {
    const urlParams = new URLSearchParams(item.url?.split('?')[1]);
    const res = await deleteProspectDocument(
      { file: urlParams.get('url')! },
      CHANGE_TRACKING_SOURCES.prospectDetails.uploadDocumentsDelete,
    );
    if (res && res.isSuccess) {
      setUploadedDocuments((prev) => prev.filter((f) => f.name !== item.name));
      handleToast(ToastType.Success, 'Prospect document deleted successfully');
    }
  };

  const customValidation = (file: File) => {
    const fileNameWithoutExtension = file.name.substring(
      0,
      file.name.lastIndexOf('.'),
    );
    if (
      uploadedDocuments().some(
        (f) => f.name.split('_')[0] === fileNameWithoutExtension,
      )
    ) {
      handleToast(ToastType.Error, 'File already exists');
      return false;
    }
    return true;
  };

  return (
    <CollapsibleCard
      startTitle={'Upload Documents'}
      loading={loading()}
      class="mb-2"
    >
      <Stack spacing={4}>
        <CommonFileUpload
          height={1}
          isMultipleUpload
          maxFileSize={5 * 1024 * 1024}
          uploadedFiles={uploadedDocuments()}
          shouldUploadOnSelect
          isRemoveFile
          apiCallBackFn={handleFileUpload}
          removeFile={handleFileRemove}
          customValidation={customValidation}
          isAdmin={isFullAdmin()}
        />
      </Stack>
    </CollapsibleCard>
  );
};
